import "antd/dist/antd.min.css";
import { Image, Rate, Button, InputNumber, Radio } from "antd";
import React, { useEffect, useState } from "react";
import APIService from "../services/APIService";
import InputNumberCart from "./InputNumberCart";
import AgencyItem from "./items/AgencyItem";
import { priceFormat, queryParams } from "../utils";
import {
  Navigate,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { store } from "../app/store";
import { addItem, buyNow, saveDrugStore } from "../app/features/cart";
import { images } from "../assets";
import SButton from "./SButton";

export default function  InfoProduct() {
  const [visible, setVisible] = useState(false);
  const [indexImage, setIndexImage] = useState(0);
  const [indexUnit, setIndexUnit] = useState(0);
  const navigate = useNavigate();
  const [productDetails, setProductDetails] = useState({
    units: [],
  });
  const [topSuggets, setTopSugeets] = useState({});
  const [quantity, setQuantity] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();
  const masterId = searchParams.get("masterId");
  const storeId = searchParams.get("storeId");
  const drugId = searchParams.get("drugId");
  const unitId = searchParams.get("unitId");
  async function getProductDetails() {
    const RESULT = await APIService.getProductDetails(drugId);
    if (RESULT) {
      setProductDetails(RESULT);
    }
  }

  async function getTopSuggets(limit, drug_id, unit_id) {
    const RESULT = await APIService.getTopSuggets(limit, drug_id, unit_id);
    if (RESULT) {
      setTopSugeets(RESULT);
    }
  }

  useEffect(() => {
    getProductDetails();
  }, [drugId]);

  useEffect(() => {
    if (productDetails?.units?.length > 0) {
      getTopSuggets(2, drugId, productDetails?.units[indexUnit]?.id);
    }
  }, [indexUnit, productDetails]);

  useEffect(() => {
    if (productDetails?.units?.length > 0 && unitId) {
      const index = productDetails?.units.findIndex(
        (item) => item.id == unitId
      );
      setIndexUnit(index);
    }
  }, [unitId]);

  const onAddItem = (e) => {
    store.dispatch((dispatch, getState) =>
      addItem(dispatch, getState, {
        unit_id: productDetails?.units[indexUnit]?.id,
        drug_id: productDetails?.drug_id,
        quantity: quantity,
      })
    );
  };

  const onSeleteAgency = (agentproduct) => {
    let params = queryParams({
      drugId: agentproduct.drug_id,
    });
    setSearchParams(params);
  };

  const renderAgencySugget = (item) => {
    return (
      <button
        onClick={() => onSeleteAgency(item)}
        className={`flex justify-center py-2 pl-3 pr-7 border-solid rounded flex-col ${
          item.drug_id == drugId
            ? `border-[2px] border-main-blue`
            : `border-[1px] border-[#D9D9D9]`
        }`}
      >
        <span className="text-sm not-italic font-normal capitalize">
          {item?.drug_store_name}
        </span>
        <span className="text-sm not-italic font-bold capitalize text-[#2297D4]">
          {priceFormat(item?.out_price)}
        </span>
      </button>
    );
  };

  const onBuyNow = () => {
    store.dispatch((dispatch, getState) =>
      buyNow(
        dispatch,
        getState,
        {
          unit_id: productDetails?.units[indexUnit]?.id,
          drug_id: productDetails?.drug_id,

          quantity: quantity,
        },
        () => {
          dispatch(saveDrugStore(storeId));
          navigate("/cart");
        }
      )
    );
  };

  return (
    <>
      <div className="mb-3 sm:mb-6 text-[14px] sm:text-lg not-italic font-extrabold">
        {productDetails?.category_name}
      </div>
      <div className="flex flex-col sm:flex-row ">
        <div>
          <Image
            className="object-cover rounded-[12px] h-[349px] sm:w-[420px] md:h-[420px] sm:h-[340px]"
            preview={{ visible: false }}
            src={
              (productDetails?.images && productDetails.images[indexImage]) ||
              images.logoPNG
            }
            onClick={() => setVisible(true)}
          />
          <div style={{ display: "none" }}>
            <Image.PreviewGroup
              preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
            >
              {productDetails?.images?.map((item, index) => (
                <Image key={index} src={item || images.logoPNG} />
              ))}
            </Image.PreviewGroup>
          </div>
          <div className="flex justify-between max-w-[420px] mt-3">
            {productDetails?.images?.map((item, index) => (
              <Image
                className="block object-cover rounded-[12px] hover:shadow-lg w-[111px] h-[111px] sm:w-[134px] sm:h-[134px]"
                preview={false}
                src={item || images.logoPNG}
                onClick={() => setIndexImage(index)}
              />
            ))}
          </div>
        </div>
        <div className="flex-col flex-1 ml-0 fle sm:ml-6">
          <div className="flex flex-col items-start flex-1 sm:justify-between">
            <div>
              <p className="text-[14px] sm:text-lg mt-3 sm:mt-0 not-italic font-extrabold">
                {productDetails?.drug_name}
              </p>

              <div className="flex items-center">
                <h5 className="font-bold text-[18px] text-[#2297D4]">
                  {priceFormat(productDetails?.units[indexUnit]?.out_price)}
                </h5>
                <span className="ml-6 price-old">
                  {priceFormat(productDetails?.units[indexUnit]?.out_price_org)}
                </span>
              </div>
              <div className="flex flex-row mt-4 mb-3">
                <Radio.Group
                  value={indexUnit}
                  buttonStyle="outline"
                  onChange={(e) => setIndexUnit(e.target.value)}
                >
                  {productDetails?.units?.map((item, index) => (
                    <Radio.Button value={index}>{item.name}</Radio.Button>
                  ))}
                </Radio.Group>
              </div>
            </div>
            {drugId && (
              <div className="text-[12px] sm:text-sm flex items-center sm:items-stretch sm:flex-col mb-4 gap-[17px] sm:gap-[0px]">
                Số lượng
                <InputNumberCart
                  onChange={(value) => setQuantity(value)}
                  value={quantity}
                />
              </div>
            )}

            <div className="mb-2 text-[10px] sm:text-sm">
              <p className="flex flex-row mb-2 font-light">
                Mã dược Quốc Gia:
                <p className="ml-1.5 font-bold">{productDetails?.drug_code}</p>
              </p>
              <p className="flex flex-row font-light">
                Đã bán:
                <p className="ml-1.5 font-bold">
                  {productDetails?.countTotalSell} sản phẩm
                </p>
              </p>
            </div>

            {productDetails?.drugStore && (
              <button
                className="block w-full"
                onClick={(e) => {
                  navigate(
                    `/agency-details?agencyId=${productDetails.drugStore.id}`
                  );
                }}
              >
                <AgencyItem data={productDetails.drugStore} />
              </button>
            )}
            {drugId && (
              <div className="flex flex-row w-full mb-5 ">
                <SButton
                  onClick={onBuyNow}
                  className="text-[10px] sm:text-lg button text-white rounded-3xl flex-1 md:w-[252px] sm:w-[230px] h-[50px] font-bold hover:text-white bg-main-blue hover:bg-main-blue active:bg-main-blue focus:bg-main-blue hover:border-main-blue active:text-white  active:border-main-blue focus:border-main-blue focus:text-main-white mr-4"
                >
                  MUA NGAY
                </SButton>
                <SButton
                  onClick={onAddItem}
                  className="text-[10px] sm:text-lg button text-green border-2 flex-1 rounded-3xl md:w-[252px] sm:w-[230px] h-[50px] font-bold hover:text-green border-green hover:border-green active:text-green  active:border-green focus:border-green focus:text-green"
                >
                  THÊM VÀO GIỎ HÀNG
                </SButton>
              </div>
            )}

            <div className="flex flex-col gap-y-3">
              {topSuggets["sell-top"]?.length > 0 && (
                <div className="flex flex-col gap-y-1">
                  <span className="text-base font-bold text-[#222222] not-italic capitalize">
                    Bán Nhiều Nhất
                  </span>
                  <div className="grid grid-cols-3 gap-[10px]">
                    {topSuggets["sell-top"]?.map(renderAgencySugget)}
                  </div>
                </div>
              )}
              {topSuggets["price-shortest"]?.length > 0 && (
                <div className="flex flex-col gap-y-1">
                  <span className="text-base font-bold text-[#222222] not-italic capitalize">
                    Giá Thấp nhất
                  </span>
                  <div className="grid grid-cols-3 gap-[10px]">
                    {topSuggets["price-shortest"]?.map(renderAgencySugget)}
                  </div>
                </div>
              )}
              {topSuggets["address-shortest"]?.length > 0 && (
                <div className="flex flex-col gap-y-1">
                  <span className="text-base font-bold text-[#222222] not-italic capitalize">
                    Gần bạn nhất
                  </span>
                  <div className="grid grid-cols-3 gap-[10px]">
                    {topSuggets["address-shortest"]?.map(renderAgencySugget)}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <h2 className="text-[12px] sm:text-base font-extrabold text-[#222222] sm:leading-9">
        Thông tin
      </h2>
      <div className="sm:h-[180px] mt-2 sm:mt-4">
        <p className="text-[10px] sm:text-base font-bold ">Chi Tiết sản phẩm</p>
        <div className="max-w-[1307px] h-[2px] bg-[#EBEBEB] my-4">
          <div className="h-full w-[60px] rounded-lg bg-[#119AE2]"></div>
        </div>
        <p className="text-[10px] sm:text-sm	font-semibold mt-2.5">Mô tả:</p>
        <p className="text-[10px] sm:text-sm	font-normal sm:leading-6 text-[#222222] mt-2sm:mt-2.5">
          {productDetails?.description}
        </p>
        <p className="text-[10px] sm:text-sm	font-semibold mt-2.5 leading-6 text-[#222222]">
          Công thức với:
        </p>
        <p className="text-[10px] sm:text-sm	">{productDetails?.substances}</p>
      </div>
    </>
  );
}
